<template>
  <div>
      <group-card title="Services" icon="card_membership" padded>
          <div>
            <data-table
              :headers="headers"
              v-model="services"
              :items-per-page="10"
              filterable
            >
              <template v-slot:item.actions="{ item }">
                  <md-switch class="md-layout-item" v-model="item.subscribed" @change="editService(item)" />
              </template>
            </data-table>
          </div>
      </group-card>
  </div>
</template>
<script>
import DataTable from "@/components/DataTable";
import { GroupCard } from "@/components";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";

export default {
  components: {
    DataTable,
    GroupCard,
    ConfirmDialog
  },
  data() {
    return {
      services: [],
      headers: [
        {
          text: "Name",
          value: "name",
          width: '500px',
          search: true,
          sort: true
        },
        {
          text: "Description",
          value: "description",
          search: true,
          sort: false
        },
        {
          text: "Subscribe/Unsubscribe",
          value: "actions",
          width: '200px',
          optional: false,
        },
      ],
    }
  },
  created() {
    this.getServices();
  },
  methods: {
    async getServices(){
      try {
        let result = await axios.get(`/api/v1/zink_services`);
        this.services = result.data;
      } catch (e) {
        console.log(e)
        this.showConfirmDialog("Error", "Service list could not be loaded");
      }
    },
    async editService (service) {
      await axios.post(
        "/api/v1/zink_services",
        {
          id: service.id,
          subscribed: service.subscribed
        }
      ).then(() => {
        if(service.subscribed){
          this.showConfirmDialog("Success", "You successfully subscribed to the selected service");
        } else {
          this.showConfirmDialog("Success", "You successfully unsubscribed to the selected service");
        }
        return true;
      }).catch((err) => {
        this.showConfirmDialog("Error", "Service could not be updated");
        return false;
      });
    },
    showConfirmDialog(title, message) {
          this.$modal.show(ConfirmDialog, {
            title: title,
            message: message,
            confirmText: 'Ok',
      });
    }
  }
}
</script>